import { render, staticRenderFns } from "./ViewClasses.vue?vue&type=template&id=48731391"
import script from "./ViewClasses.vue?vue&type=script&lang=js"
export * from "./ViewClasses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports